export default "__VITE_ASSET__fba665d0__"